import {useState, useEffect} from 'react'
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge"
import { getCampaigns } from "api/campaigns/getCampaigns";
import { useTokenContext } from 'App';
import { timeConverter } from 'timeConverter/timeConverter';
import ModalDialog from "components/ModalDialog/ModalDialog";
import ModalCampaignData from './data/modalCampaignData';

import {getPhotoSource} from "api/requests"
import {readStream} from "readStream/readStream"

/* eslint-disable react/prop-types */
function RetailerCampaigns() {

  const {token} = useTokenContext();
  const [campaigns, setCampaigns] = useState(null)
  const [myStorage, setMyStorage] = useState([])
  const [nrPhotosDownloaded, setNrPhotosDownloaded] = useState(0)
  const [showModal, setShowModal] = useState(false);
  const [campaign, setCampaign] = useState(null)

  function formatType(type){
    const lowercaseType =  type.toLowerCase().replace(/_/g, " ")
    return lowercaseType.charAt(0).toUpperCase() + lowercaseType.slice(1)
  }

  function onViewClick(campaign){
    setShowModal(true)
    setCampaign(campaign)
  }

  function onCloseModalClick(){
    setShowModal(false)
  }

  const doGetCampaigns = async () => {
    try {
      let campaignsPromise = await getCampaigns(token);
      setCampaigns(campaignsPromise);

    } catch (error) {
      console.error("Error on getting company: ", error);
    }
  }

  useEffect(() => {
    doGetCampaigns();
  }, [])

  useEffect(() => {
    if(campaigns){
        let noPicsCampaigns = ['PERSONAL_DATA', 'PRODUCT_DEFAULT'];
        for(var i=0; i < campaigns["data"]["campaigns"].length; i++){
          if(campaigns['data']['campaigns'][i]['campaign']['type'] in noPicsCampaigns){
            continue;
          }
          const shopLogoId = campaigns["data"]["campaigns"][i]["shop"]["logo_id"]
          if(campaigns['data']['campaigns'][i]['campaign']['type'] === 'SHOP'){
            if(localStorage.getItem(shopLogoId) === null){
              getPhotoSource(shopLogoId, token)
              .then(response => {
                const reader = response.body.getReader();
                readStream(reader)
                .then(base64Response => {
                  localStorage.setItem(shopLogoId, base64Response)
                  setNrPhotosDownloaded(nr => nr+1)
                })
                
              })
            }
          }
          if(campaigns['data']['campaigns'][i]['campaign']['type'] === 'PRODUCT'){
            const productPhotoId = campaigns["data"]["campaigns"][i]["product"]["product_photos_ids"][0]
            if(localStorage.getItem(productPhotoId) === null){
              getPhotoSource(productPhotoId, token)
              .then(response => {
                const reader = response.body.getReader();
                readStream(reader)
                .then(base64Response => {
                  localStorage.setItem(productPhotoId, base64Response)
                  setNrPhotosDownloaded(nr => nr+1)
                })
              })
            }
          }
        }
      }
  }, [campaigns, token]);


  useEffect(() => {
    setMyStorage(localStorage)
  }, [nrPhotosDownloaded])

  const campaignImage = (campaign) => {
    if(campaign['campaign']['type'] === 'SHOP'){
      let src = 'data:image/png;base64,' + myStorage[campaign['shop']['logo_id']];
      return <img src={src} style={{maxHeight:"4rem", marginRight:20}}/>
    }
    if(campaign['campaign']['type'] === 'PRODUCT'){
      let src = 'data:image/png;base64,' + myStorage[campaign['product']['product_photos_ids'][0]];
      return <img src={src} style={{maxHeight:"12rem", borderRadius:20, marginRight:20}}/>
    }
  }

  const modalData = <ModalCampaignData campaign={campaign} campaignImage={campaignImage}/>

  return (
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDButton variant="gradient" color="dark" size="medium">
            <MDTypography variant="caption" fontWeight="medium" color="light">{" + Start new campaign"}</MDTypography>
        </MDButton>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            {campaigns && campaigns['data']['campaigns'].map((campaign) => (
              <Grid item xs={12} md={6} lg={4} key={campaign['campaign']['id']}>
                <MDBox mb={3}>
                  <Card sx={{ height: "100%"}}>
                    <MDBox padding="1rem">
                      <MDBox display="flex" justifyContent="space-between">
                        <MDButton iconOnly={false} sx={{marginLeft:0, padding:1}} onClick={() => onViewClick(campaign)}>
                            <Icon>visibility</Icon>&nbsp;view
                        </MDButton>
                        {(campaign['campaign']['type'] === "PERSONAL_DATA" || campaign['campaign']['type'] === "PRODUCT_DEFAULT")  &&
                          <MDBadge badgeContent="System" color="error" variant="gradient" size="md"  />
                        }
                      </MDBox>
                      <MDBox pt={1} pb={1} px={1}>
                        <MDBox display="flex" justifyContent="left" alignItems="center">
                          {campaignImage(campaign)}
                          <MDBox>
                            <MDBox display="flex" alignItems="center" justifyContent="space-between">
                              <MDTypography variant="h6" textTransform="capitalize">
                                {formatType(campaign['campaign']['type'])}
                              </MDTypography>
                            </MDBox>
                            <MDTypography component="div" variant="button" color="text" fontWeight="light">
                              {campaign['campaign']['description']}
                            </MDTypography>
                            <MDBox display="flex" mt={1} alignItems="center">
                              <MDTypography component="div" variant="button" color="text" fontWeight="light" mr={2}>
                                  {'Campaign type:'}
                              </MDTypography>
                              <MDBox>
                                {'survey_definition_id' in campaign['campaign'] && 
                                  <MDTypography component="div" variant="button" color="text" fontWeight="medium">
                                    {'SURVEY'}
                                  </MDTypography>
                                }
                                {'discounts' in campaign['campaign'] && 
                                  <MDTypography component="div" variant="button" color="text" fontWeight="medium">
                                    {'DISCOUNT'}
                                  </MDTypography>
                                }
                              </MDBox>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                        <Divider />
                        <MDBox display="flex" alignItems="center">
                          <MDTypography variant="button" color="text" lineHeight={1} sx={{ mt: 0.15, mr: 0.5 }}>
                            <Icon>schedule</Icon>
                          </MDTypography>
                          <MDTypography variant="button" color="text" fontWeight="light">
                            {timeConverter(campaign['campaign']['start_date']) +  " - " + timeConverter(campaign['campaign']['end_date'])}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            ))}
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
    {showModal &&
      <>
      {(campaign['campaign']['type'] === "PERSONAL_DATA" || campaign['campaign']['type'] === "PRODUCT_DEFAULT")  ? (
        <ModalDialog 
          onCloseModalClick={onCloseModalClick} 
          title={formatType(campaign["campaign"]["type"]) + ' campaign'}
          rightTitle={"System"}
          content={modalData}
        />)
      : (
      <ModalDialog 
        onCloseModalClick={onCloseModalClick} 
        title={formatType(campaign["campaign"]["type"]) + ' campaign'} 
        content={modalData}
      />)
    }
    </>
    }

    </>
  );
}

export default RetailerCampaigns;
